import React, { forwardRef } from 'react';

import { Control, Tooltip } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { viewerCan } from '@vlabs/pages/auth/selectors';

const ChechboxWithPermissionsComponent = forwardRef(({
  permissions,
  disabled,
  title,
  can,
  ...props
}, externalRef) => {
  const { t } = useTranslation();
  const { rules, method = 'oneof' } = permissions;

  const hasPermission = can(rules, { method });
  const isDisabled = !hasPermission || disabled;

  return (
    <Tooltip
      data-tooltip-content={!hasPermission ? t('btn.insufficient_permissions.title') : null}
    >
      <Control.Checkbox
        disabled={isDisabled}
        ref={externalRef}
        title={title}
        {...props}
      />
    </Tooltip>
  );
});

ChechboxWithPermissionsComponent.propTypes = {
  permissions: PropTypes.shape({
    rules: PropTypes.arrayOf(PropTypes.string).isRequired,
    method: PropTypes.oneOf(['oneof', 'allof']),
  }),
  disabled: PropTypes.bool,
  can: PropTypes.func.isRequired,
  title: PropTypes.string,
};

ChechboxWithPermissionsComponent.defaultProps = {
  permissions: { rules: [], method: 'oneof' },
  disabled: false,
  title: '',
};

export const ChechboxWithPermissions = connect((state) => ({
  can: viewerCan(state),
}))(ChechboxWithPermissionsComponent);
